import { TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';

const FieldNotaEstudiante = ({ id, nota, onChange, onKeyDown }) => {
  const entidadesStore = Redux.useSelector((state) => state.entidades);

  return (
    <TextField
      fullWidth
      size="small"
      sx={{ minWidth: '80px' }}
      id={id}
      value={nota ?? ''}
      autoFocus
      onKeyDown={onKeyDown}
      onChange={(e) => {
        const text = e.target.value;
        if (
          text.length <= 2 &&
          text <= entidadesStore.ajustes.ponderacion &&
          text >= 0
        ) {
          onChange(text);
        }
      }}
      type="number"
      InputProps={{
        inputProps: {
          min: 0,
          max: entidadesStore.ajustes.ponderacion,
        },
      }}
    />
  );
};

export default FieldNotaEstudiante;
